import GroupPriviligesForm from './GroupPrivilegesForm';

export * from './GroupPrivilegesForm';

export default GroupPriviligesForm;
